import { useEffect, useState } from 'react';
import './customer-collection.css';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { FaEdit, FaTimes, FaChevronDown } from "react-icons/fa";
import { FaXmark, FaArrowRotateRight } from "react-icons/fa6";
import Swal from "sweetalert2";

function CustomerCollection () {
  const [clientsData, setClientsData] = useState([]);
  const [restoreClientsData, setRestoreClientsData] = useState([]);
  const [idClient, setIdClient] = useState(null);
  const [createModal, setCreateModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [restoreModal, setRestoreModal] = useState(false);
  const [updateTrigger, setUpdateTrigger] = useState(false);
  const { handleSubmit, register, reset, setValue, formState: {errors, isValid} } = useForm();

  useEffect(() => {
    getClients();
  }, [updateTrigger]);

  const statusModal = (status, id_code) => {
    if(status === "create") {
      setCreateModal(true);
    } else if (status === "update"){
      setUpdateModal(true);
      setIdClient(id_code);
    } else if(status === "restore") {
      setRestoreModal(true);
      getRestoreClients();
    } else {
      setCreateModal(false);
      setUpdateModal(false);
      setRestoreModal(false);
      reset();
    }
  }

  const getClients = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_ADMIN}/customer`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          },
        }
      );

      setClientsData(response.data.data.customer);
    } catch (error) {
      Swal.fire("Error", "Hubo un error", "error");
    }
  };

  const getRestoreClients = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_ADMIN}/customer/deleted`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          },
        }
      );
      setRestoreClientsData(response.data.data.customer);
    } catch (error) {
      Swal.fire("Error", "Hubo un error", "error");
    }
  };
  
  const createClient = async (data) => {
    console.log(data);

    try {
      const response = await axios.post(`${process.env.REACT_APP_URL_DOMESTIC_BACKEND_ADMIN}/customer`, data, 
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          }
        }
      )

      Swal.fire("¡Creado!", "creado exitosamente.", "success");
      setUpdateTrigger(!updateTrigger);
      statusModal();

    } catch(error) {
      console.error(error);
      let errorMessage = "No se ha creado ningún cliente."
      if(error.response.data.error) {
        errorMessage = error.response.data.error
      }
      Swal.fire(
        "Error al crear el Cliente",
        errorMessage
      );
    }
  }

  const restorageStation = async (code) => {
    try {
      const response = await axios.put(`${process.env.REACT_APP_URL_DOMESTIC_BACKEND_ADMIN}/customer/restore/${code}`, {}, 
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      Swal.fire("¡Restaurado!", "Estacion restaurada exitosamente.", "success");
      setUpdateTrigger(!updateTrigger);
      statusModal();
    } catch (error) {
      Swal.fire("Error", "Algo salió mal por favor intentalo mas tarde");
    }
  }

  const updateStation = async (data) => {
    try {
      
      const response = await axios.put(`${process.env.REACT_APP_URL_DOMESTIC_BACKEND_ADMIN}/customer/${idClient.id}`, data,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          }
        }
      );

      if (response.data.code === 1) {
        Swal.fire("¡Exitoso!", "Editado exitosamente.", "success");
        setUpdateTrigger(!updateTrigger);
      }
      statusModal();
    } catch(error) {
      console.error(error);
      Swal.fire(
        "Error al editar el Estacion",
        "No se ha editado ninguna estación.",
        "error"
      );
      statusModal();
    }
  }

  const deleteStation = async (code) => {
      try {
        
        const result = await Swal.fire({
          title: "¿Estás seguro?",
          text: "este cliente sera eliminado",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sí, eliminarlo",
          cancelButtonText: "No, cancelar",
          reverseButtons: true,
          buttonsStyling: true,
        });
  
        if (result.isConfirmed) {
          await axios.delete(
            `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_ADMIN}/customer/${code}`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );
  
          Swal.fire("¡Eliminado!", "Eliminado Exitosamente.", "success");
          setUpdateTrigger(!updateTrigger);
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire("Cancelado", "No se realizo ninguna acción", "error");
        }
        statusModal();
      } catch (error) {
        Swal.fire("Error", "Algo salió mal");
      }
    };

  return (
    <>
      <div className="panel-table">
        <div className='colum-left'></div>
        <div className='colum-rigth'>
          <button className="btnn" onClick={() => statusModal('create')}>
            Crear Usuario
          </button>

          <button className="btnn" onClick={() => statusModal('restore')}>
            Restore
          </button>
        </div>
      </div>
      <div className='table-responsive'>
        <table className='table table-preve'>
          <thead>
            <tr>
              <th>Nombre del cliente</th>
              <th>Numero</th>
              <td className='accions'>Acciones</td>
            </tr>
          </thead>

          <tbody>
            {clientsData.map((client, index) => (
              <tr key={index}>
                <td>{ client.name }</td>
                <td>{ client.number }</td>
                <td>
                  <FaEdit className='editButton' onClick={() => {statusModal('update', client)}} />
                  <FaTimes className='deleteButton' onClick={() => deleteStation(client.id)} />
                  </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* =====================================================
      CREATE Stations Modal
      ===================================================== */}
      {createModal && (
        <div className="station-modal">
          <div className="bg-modal-station" onClick={statusModal}></div>

          <section>
            <div className="header-station">
              <div></div>
              <h4>Crear Cliente</h4>
              <div className="close-modal" onClick={statusModal} style={{fontSize: "1.5rem", cursor: "pointer"}}>
                <FaXmark />
              </div>
            </div>

            <div className="body-station">
                <form onSubmit={handleSubmit(createClient)}>
                  <div className="input-container-stations">
                    <label>Nombre:</label>
                    <input id="name" type="text" placeholder="" {...register("name", {required: "true"})} autoComplete="off" />
                  </div>

                  <div className="input-container-stations">
                    <label>Numero:</label>
                    <input
                      id="number"
                      type="text"
                      {...register("number", { required: true })}
                      onKeyDown={(e) => {
                        if (!/[0-9]/.test(e.key) && e.key !== "Backspace") {
                          e.preventDefault();
                        }
                      }}
                      autoComplete="off"
                    />
                  </div>
                  
                  <div className="btn-container-stations">
                    <button type="submit" className={"validClass"}>Enviar</button>
                    <button type="button" className="closeModal" onClick={statusModal}>Cerrar</button>
                  </div>

                </form>
            </div>
          </section>
        </div>
      )}

      {/* =====================================================
      UPDATE Stations Modal
      ===================================================== */}
      {updateModal && (
        <div className="station-modal">
          <div className="bg-modal-station" onClick={statusModal}></div>

          <section>
            <div className="header-station">
              <div></div>
              <h4>Editar Cliente</h4>
              <div className="close-modal" onClick={statusModal} style={{fontSize: "1.5rem", cursor: "pointer"}}>
                <FaXmark />
              </div>
            </div>

            <div className="body-station">
                <form onSubmit={handleSubmit(updateStation)}>
                  <div className="input-container-stations">
                    <label>Nombre:</label>
                    <input id="name" type="text" placeholder="" {...register("name", {required: "true"})} autoComplete="off" />
                  </div>

                  <div className="input-container-stations">
                    <label>Numero:</label>
                    <input
                      id="number"
                      type="text"
                      {...register("number", { required: true })}
                      onKeyDown={(e) => {
                        if (!/[0-9]/.test(e.key) && e.key !== "Backspace") {
                          e.preventDefault();
                        }
                      }}
                      autoComplete="off"
                    />
                  </div>
                  
                  <div className="btn-container-stations">
                    <button type="submit" className={"validClass"}>Enviar</button>
                    <button type="button" className="closeModal" onClick={statusModal}>Cerrar</button>
                  </div>

                </form>
            </div>
          </section>
        </div>
      )}

      {/* =====================================================
      RESTORE Stations Modal
      ===================================================== */}
      {restoreModal && (
        <div className="station-modal">
          <div className="bg-modal-station" onClick={statusModal}></div>

          <section>
            <div className="header-station">
              <div></div>
              <h4>Restaurar estacion</h4>
              <div className="close-modal" onClick={statusModal} style={{fontSize: "1.5rem", cursor: "pointer"}}>
                <FaXmark />
              </div>
            </div>

            <div className="body-station">
                <div className="stationsRestoreContainer" style={{width: "100%"}}>

                  {restoreClientsData.length !== 0 ? (
                    <table className="table table-preve" id="tableRestore">
                      <thead>
                        <tr>
                          <th>Nombre</th>
                          <td className="accions">Acciones</td>
                        </tr>
                      </thead>

                      <tbody>
                        {restoreClientsData.map((station) => (
                          <tr>
                            <td>{station.name}</td>
                            <td>
                              <div className="buttonsRestore">
                                <FaArrowRotateRight
                                  className="editButton"
                                  onClick={() => restorageStation(station.id)}
                                />
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ): (<>
                    <p style={{width: "100%", padding: "20px 0", fontSize: "1.2rem", textAlign: "center", fontWeight: "bold"}}>No hay Clientes por restaurar</p>
                  </>)}

                </div>
            </div>
          </section>
        </div>
      )}
    </>
  )
}

export default CustomerCollection;